import { combineReducers,configureStore } from "@reduxjs/toolkit";
import { reducer as LangReducer} from "../reducers/lang";
import { reducer as TypePayReducer } from "../reducers/TypePayment";
import { reducer as StepReducer } from "../reducers/Step";
import { reducer as StepOneReducer } from "../reducers/StepOne";
import { reducer as StepTwoReducer } from "../reducers/StepTwo";
import { reducer as StepPay } from "../reducers/StepPay";
import logger from "redux-logger";

const rootReducers = combineReducers({
    lang: LangReducer,
    typepay: TypePayReducer,
    step: StepReducer,
    stepone: StepOneReducer,
    steptwo: StepTwoReducer,
    steppay: StepPay
});


export const store = configureStore({
    devTools: true,
    reducer: rootReducers,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }).concat(logger),
})